import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _applyDecoratedDescriptor from '@babel/runtime/helpers/esm/applyDecoratedDescriptor';
import { extension, ExtensionPriority, command, NodeExtension, ExtensionTag, chainCommands, convertCommand } from '@remirror/core';
import { exitCode } from '@remirror/pm/commands';

var _dec, _dec2, _class, _class2;
var HardBreakExtension = (_dec = extension({
  defaultPriority: ExtensionPriority.Low
}), _dec2 = command(), _dec(_class = (_class2 = class HardBreakExtension extends NodeExtension {
  get name() {
    return 'hardBreak';
  }

  createTags() {
    return [ExtensionTag.InlineNode];
  }

  createNodeSpec(extra, override) {
    var _override$parseDOM;

    return _objectSpread(_objectSpread({
      inline: true,
      selectable: false,
      atom: true
    }, override), {}, {
      attrs: extra.defaults(),
      parseDOM: [{
        tag: 'br',
        getAttrs: extra.parse
      }, ...((_override$parseDOM = override.parseDOM) !== null && _override$parseDOM !== void 0 ? _override$parseDOM : [])],
      toDOM: node => ['br', extra.dom(node)]
    });
  }

  createKeymap() {
    var command = chainCommands(convertCommand(exitCode), () => {
      this.store.commands.insertHardBreak();
      return true;
    });
    return {
      'Mod-Enter': command,
      'Shift-Enter': command
    };
  }
  /**
   * Inserts a hardBreak `<br />` tag into the editor.
   */


  insertHardBreak() {
    return props => {
      var tr = props.tr,
          dispatch = props.dispatch; // Create the `hardBreak`

      dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr.replaceSelectionWith(this.type.create()).scrollIntoView());
      return true;
    };
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "insertHardBreak", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "insertHardBreak"), _class2.prototype)), _class2)) || _class);

export { HardBreakExtension };
